import { render, staticRenderFns } from "./SynonymsCreatePopup.vue?vue&type=template&id=08fcdb30"
import script from "./SynonymsCreatePopup.vue?vue&type=script&lang=js"
export * from "./SynonymsCreatePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports